export const languageList = [
  {
    id: 1,
    code: "en",
    name: "English",
  },
  {
    id: 2,
    code: "es",
    name: "Spanish",
  },
  {
    id: 3,
    code: "el",
    name: "Greek",
  },
  {
    id: 4,
    code: "fr",
    name: "French",
  },
  {
    id: 5,
    code: "ar",
    name: "Arabic",
  },
];
export const languageObj: any = {
  "1": "en",
  "2": "es",
  "3": "el",
  "4": "fr",
  "5": "ar",
};

export const componentList = [
  { name: "Signup", id: 1, displayName: "Sign Up" },
  { name: "Login", id: 2, displayName: "Sign In" },
  { name: "Common", id: 3, displayName: "Common" },
  { name: "Createjob", id: 4, displayName: "Create Job" },
  { name: "LoginViaOTP", id: 5, displayName: "Login Via OTP" },
  { name: "Jobfilter", id: 6, displayName: "Job Filter" },
  { name: "Jobslist", id: 7, displayName: "Jobs List" },
  { name: "TaskDetail", id: 8, displayName: "Task Detail" },
  { name: "Sidebar", id: 9, displayName: "Sidebar" },
  { name: "Contactlist", id: 10, displayName: "Contactlist" },
  { name: "Analytics", id: 11, displayName: "Analytics" },
  { name: "Header", id: 12, displayName: "Header" },
  { name: "Profile", id: 13, displayName: "Profile" },
];
export const componentObj: any = {
  1: "Signup",
  2: "Login",
  3: "Common",
  4: "Createjob",
  5: "LoginViaOTP",
  6: "Jobfilter",
  7: "Jobslist",
  8: "TaskDetail",
  9: "Sidebar",
  10: "Contactlist",
  11: "Analytics",
  12: "Header",
  13: "Profile",
};
